// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2kx2O","wrapper":"styles__wrapper___2XK4g","heading":"styles__heading___39lW4","listItem":"styles__listItem___fdowF","name":"styles__name___28jyN"};